import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import classnames from 'classnames';
import Media from 'react-media';
import Avatar from 'react-toolbox/lib/avatar';
import Button from '../../../../common/components/Button';
import { Card } from 'react-toolbox/lib/card';
import FontIcon from 'react-toolbox/lib/font_icon';
import styles from './ActivityList.css';

export const displayProps = props => {
  if (!props) {
    return null;
  }
  return Object.keys(props).map(propKey => {
    const prop = props[propKey];
    let propValue = prop;
    let propClass = null;
    if (typeof prop === 'object') {
      propValue = prop.value || '';
      propClass = prop.className;
    }
    return propValue ? (
      <span className={propClass} key={propKey}>
        {propValue}
      </span>
    ) : null;
  });
};

const ActivityListTile = ({
  activity,
  className,
  theme: { colors },
  mobileIcon = false,
}) => {
  return (
    <Media query="(min-width: 768px)">
      {matches => {
        const { icon, action, details, image } = activity;
        const activityColor = colors[activity.color] || '#757575';
        const actionColor = '#333333';
        const activityDetails = displayProps(details);

        const avatarClass = classnames(styles.avatarContainer, {
          [styles.avatarContainerHide]: !mobileIcon,
        });

        return (
          <Card
            className={classnames(
              styles.activityListTile,
              { [styles.activityListTileNoIcon]: !mobileIcon },
              className
            )}
            onClick={matches ? null : (action || {}).clickHandler}
            style={{ borderColor: activityColor }}
          >
            <div className={avatarClass}>
              {typeof icon === 'function' ? (
                icon()
              ) : (
                <Avatar
                  icon={icon}
                  image={image}
                  style={!image ? { backgroundColor: activityColor } : {}}
                  className={styles.activityAvatar}
                />
              )}
            </div>
            {matches ? (
              activityDetails
            ) : (
              <div className={styles.activityDetails}>{activityDetails}</div>
            )}
            {matches
              ? !!action && (
                  <Button
                    label={action.label}
                    buttonType="text"
                    onClick={action.clickHandler}
                  />
                )
              : !!action && (
                  <FontIcon
                    value={action.icon}
                    className={styles.action}
                    style={{
                      color: colors[actionColor] || actionColor,
                    }}
                  />
                )}
          </Card>
        );
      }}
    </Media>
  );
};
ActivityListTile.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  mobileIcon: PropTypes.bool,
  activity: PropTypes.shape({
    color: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    image: PropTypes.string,
    details: PropTypes.objectOf(
      PropTypes.shape({
        value: PropTypes.string,
        className: PropTypes.string,
      })
    ),
    action: PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string,
      color: PropTypes.string,
      clickHandler: PropTypes.func.isRequired,
    }),
  }),
};

export default withTheme(ActivityListTile);



// WEBPACK FOOTER //
// ./src/App/account/components/ActivitiesPage/ActivityListTile.js